import React, { useEffect, useState } from 'react';

// Practice variant's "Logging in" screen. The eCW login check can take up to
// two minutes (Microsoft sign-in prompts), so show progress against that:
// 10% every 12 seconds, holding at 95% until the check returns.
const EXPECTED_SECONDS = 120;

export default function LoginProgress({ emrName }) {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const pct = Math.min(95, Math.floor((seconds / EXPECTED_SECONDS) * 100));
  return (
    <div className="cobalt-mt-4 cobalt-flex cobalt-flex-col cobalt-items-center cobalt-justify-center cobalt-h-full cobalt-w-full">
      <p className="cobalt-embedded-p cobalt-text-center cobalt-font-semibold">
        Connecting your {emrName} account
      </p>
      <p className="cobalt-embedded-p cobalt-text-center cobalt-text-sm cobalt-text-gray-600 cobalt-mt-1 cobalt-mb-5">
        This can take up to 2 minutes. Please keep this window open.
      </p>
      <div
        className="cobalt-w-10/12 cobalt-h-2 cobalt-rounded-full cobalt-bg-gray-200 cobalt-overflow-hidden"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
      >
        <div
          className="cobalt-h-full cobalt-rounded-full cobalt-bg-primary"
          style={{ width: `${pct}%`, transition: 'width 1s linear' }}
        />
      </div>
      <p className="cobalt-embedded-p cobalt-text-center cobalt-text-sm cobalt-text-gray-600 cobalt-mt-2">
        {pct >= 95 ? 'Almost done...' : `${pct}%`}
      </p>
    </div>
  );
}
